import { render, staticRenderFns } from "./bfCallback.vue?vue&type=template&id=24ee6ffd&"
import script from "./bfCallback.vue?vue&type=script&lang=js&"
export * from "./bfCallback.vue?vue&type=script&lang=js&"
import style0 from "./bfCallback.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports